<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2 sp-buyer-details__grid">
      <app-buyer-details-header
        [buyer_id]="buyer_id"
        (tab_change)="onTabChange($event)"
        (refresh)="onRefresh()"></app-buyer-details-header>

      <app-buyer-details-general
        *ngIf="current_tab === tabs.get('article')"
        [buyer_id]="buyer_id"></app-buyer-details-general>

      <app-buyer-details-order-data
        *ngIf="current_tab === tabs.get('receipt_long')"
        [buyer_id]="buyer_id"></app-buyer-details-order-data>

      <app-buyer-details-event-data
        *ngIf="current_tab === tabs.get('timeline')"
        [buyer_id]="buyer_id"></app-buyer-details-event-data>
    </div>
  </div>
</div>
